import React from "react";
import { connect } from "react-redux";
import { logout } from "../../store/WriteClass";
import "./index.css";
import sConfig from "../../utils/siteConfig";
import DropdownButton from "react-bootstrap/lib/DropdownButton";
import MenuItem from "react-bootstrap/lib/MenuItem";

const has_header_img =
  sConfig.headerMain() &&
  sConfig.headerMain().length > 0;
const has_header_border =
  sConfig.headerBorderColor() &&
  sConfig.headerBorderColor().length > 0;
const has_header_font_color =
  sConfig.headerFontColor() &&
  sConfig.headerFontColor().length > 0;


const headerMain = {
  height: "109px",
  background: has_header_img
    ? `url(${sConfig.headerMain()})`
    : sConfig.headerColor(),
  borderBottom: has_header_border
    ? `5px solid ${sConfig.headerBorderColor()}`
    : ""
};

const headerWelcome = {
  color: has_header_font_color
    ? `${sConfig.headerFontColor()}`
    : ""
};

let compy = ({ user, loggedIn }) => {
  let conditional = "";

  if (user && user.email && loggedIn) {
    conditional = (
      <div className="headerProfileWrapper">
        <div className="headerProfile visible-xs">
          <DropdownButton
            title={`${user.firstName} ${user.lastName}`}
            id="account-dropdown"
          >
            <MenuItem
              style={{
                minWidth: 100
              }}
              onSelect={() =>
                (window.location = process.env.REACT_APP_API_URL + "/logout")
              }
            >
              Log Out
            </MenuItem>
          </DropdownButton>
        </div>
        <div className="headerProfile hidden-xs">
          <div className="headerWelcome" style={headerWelcome}>
            Welcome, {user.firstName} {user.lastName}
          </div>
          {sConfig.logoutColor() && sConfig.logoutFontColor() ? (
            <a
              className="btn"
              role="button"
              href={process.env.REACT_APP_API_URL + "/logout"}
              style={{
                backgroundColor: sConfig.logoutColor(),
                color: sConfig.logoutFontColor()
              }}
            >
              Log Out
            </a>
          ) : (
            <a href={process.env.REACT_APP_API_URL + "/logout"} role="button">
              <img
                src={sConfig.logout()}
                className="logoutButton"
                title="Log out"
                alt="log out"
              />
            </a>
          )}
        </div>
      </div>
    );
  }

  return (
    <header>
      <div className="headerWrap">
        <div className="headerMain" style={headerMain}>
          <div className="headerInterior">
            <div className="headerLogoWrapper">
              <a href="/" title="The Write Class home">
                <img
                  src={sConfig.logo()}
                  alt={`${sConfig.schoolName()} logo`}
                  className="headerLogo"
                />
              </a>
            </div>
            {conditional}
          </div>
        </div>
      </div>
    </header>
  );
};

const mapStateToProps = state => ({
  user: state.write_class.user,
  loggedIn: state.write_class.loggedIn
});

function mapDispatchToProps(dispatch) {
  return {
    logout: () => dispatch(logout())
  };
}

const wrappedCompy = connect(
  mapStateToProps,
  mapDispatchToProps
)(compy);

export default wrappedCompy;



// WEBPACK FOOTER //
// ./src/components/appHeader/index.jsx